import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import environment from '../../../environments/environment';
import { ExtAppRouteEnum } from '../../enums/ext-app-route.enum';
import { AuthService } from '../../services/auth.service';
import { ServerErrorAction, ServerSuccessAction } from '../shared/state/toast/toast.actions';

export interface ToastObject {
    title?: string;
    message?: string;
}

@Injectable()
export class AuthHookService {
    /**
     *
     * @param _store
     * @param _authService
     * @param _router
     */
    constructor(
        private _store: Store<any>,
        private _authService: AuthService,
        private _router: Router
    ) {}

    /**
     *
     */
    postLogin() {
        this._store.dispatch(
            new ServerSuccessAction({
                title: 'Log In!',
                message: 'You have logged in successfully!',
                dismissAfter: 2000,
            })
        );
        this._authService.retreiveTokenData();

        // redirect to the aida tool
        this.handleAidaToolRedirect();
    }

    /**
     *
     */
    handleAidaToolRedirect() {
        console.log('start');
        const userData = this._authService.getUserData();
        const isFromExternalPortal = userData?.relayState;
        if (isFromExternalPortal) {
            this._router.navigate([ExtAppRouteEnum.aida]);
        }
    }

    /**
     *
     */
    postLogout() {
        this._store.dispatch(
            new ServerSuccessAction({
                title: 'Log Out!',
                message: 'You have logged out successfully!',
            })
        );
        this.clearStorageAndRedirect();
    }

    /**
     *
     * @param incidentData
     */
    customMfaLockout(incidentData: any) {
        console.log(incidentData);
        this._store.dispatch(
            new ServerErrorAction('You have been locked out, please contact support')
        );
    }

    /**
     *
     */
    federatedOnlyLoginFail() {
        this._store.dispatch(new ServerErrorAction('That Email is not supported for SSO'));
    }

    /**
     *
     * @param notification
     */
    successToast(notification: ToastObject) {
        this._store.dispatch(new ServerSuccessAction({ message: `${notification.message}` }));
    }

    /**
     *
     * @param notification
     */
    failureToast(notification: ToastObject) {
        this._store.dispatch(new ServerErrorAction(`${notification.message}`));
    }

    /**
     *
     */
    private clearStorageAndRedirect() {
        sessionStorage.setItem('returnUrl', 'logout');
        localStorage.clear();
        window.location.href = environment.externalAuthIssuer;
    }
}
